import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Clock, Flag } from 'lucide-react';
import { SkeletonBlock } from '../components/common/SkeletonBlock';
import { GlassPanel } from '../components/common/GlassPanel';

const ABOUT_FACTS = (icon1, icon2, icon3) => [
  { icon: icon1, label: "LOCATION", value: "Noida, India" },
  { icon: icon2, label: "EXPERIENCE", value: "2+ YEARS" },
  { icon: icon3, label: "FOCUS", value: "FULL STACK DEVELOPMENT" },
];

const AboutImpl = ({ accent, mood, isResolving }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen pt-32 pb-48 px-4 sm:px-4 sm:px-8 lg:px-24">
    <AnimatePresence mode="wait">
      {isResolving ? (
        <div key="skeleton" className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div className="space-y-12">
            <SkeletonBlock className="h-12 w-64 rounded-xl" />
            <SkeletonBlock className="h-64 w-full rounded-[2rem]" />
          </div>
          <div className="space-y-6">
            <SkeletonBlock className="h-32 w-full rounded-2xl" />
            <SkeletonBlock className="h-32 w-full rounded-2xl" />
            <SkeletonBlock className="h-32 w-full rounded-2xl" />
          </div>
        </div>
      ) : (
        <motion.div key="content" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start relative z-10">
          <div>
            <h2 className="text-5xl font-black italic text-white mb-12 uppercase tracking-tighter">ABOUT ME</h2>
            <GlassPanel mood={mood} className="p-6 sm:p-10 rounded-[2rem]">
              <p className="text-xl text-white/70 leading-relaxed mb-8 relative z-10">
              I’m NiKHiL, a full-stack developer who enjoys turning complex problems into clean, performant web experiences. I focus on building practical products using modern JavaScript frameworks and backend systems.
              </p>

              <p className="text-lg text-white/40 leading-relaxed relative z-10">
              Currently exploring advanced frontend animations, scalable APIs, and real-world projects that combine design with engineering. I care deeply about UI polish, performance, and writing maintainable code.
              </p>
            </GlassPanel>
          </div>
          <div className="grid grid-cols-1 gap-6">
            {ABOUT_FACTS(<MapPin size={20} />, <Clock size={20} />, <Flag size={20} />).map((item, i) => (
              <GlassPanel key={i} mood={mood} className="flex items-center gap-8 p-8 rounded-2xl group transition-colors hover:border-white/10">
                <div className="p-5 rounded-xl bg-white/5 group-hover:scale-110 transition-transform" style={{ color: accent.color }}>{item.icon}</div>
                <div><p className="text-[10px] uppercase text-white/30 font-black mb-1">{item.label}</p><p className="text-2xl font-black text-white italic tracking-tighter uppercase">{item.value}</p></div>
              </GlassPanel>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </motion.div>
);

export const About = React.memo(AboutImpl);
